// @owners { team: patient-health }
import { push } from 'react-router-redux';
import { openPrepInfoModal, setSelectedVideo } from '~shared/actions/instructionalVideos';
import { type Video } from '~shared/features/instructional-videos/types';
import { connect } from '~shared/store';
import { type ReduxDispatchShared } from '~shared/types';
import MedListInstructionalVideos from './MedListInstructionalVideos';

function mapDispatchToProps(dispatch: ReduxDispatchShared) {
  return {
    navigateToVideosPage: () => {
      dispatch(setSelectedVideo(null));
      dispatch(push('/me/fertility-videos'));
    },
    openVideoPrepInfoModal: (video: Video) => {
      dispatch(openPrepInfoModal(video));
    },
  };
}

export default connect(null, mapDispatchToProps)(MedListInstructionalVideos);
